export const FIELD_KEYS = {
  IDENTIFICACAO: 'identificacao',
  UNIDADE: 'unidade',
  SETOR: 'setor',
  SUB_SETOR: 'sub_setor',
  LOCALIZACAO: 'localizacao',
  NOME_OS: 'nome_os',
  TIPO_OS: 'tipo_os',
  RESPONSAVEL: 'responsavel',
  SOLICITANTE: 'solicitante',
  DATA_HORA_SOLICITACAO: 'data_hora_solicitacao',
  SOLICITACAO_RECLAMACAO: 'solicitacao_reclamacao',
  OFICINA: 'oficina',
}
